"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.popStudyGameplayTheme = exports.popQuizHostGameplayTheme = exports.popQuizGameplayTheme = exports.popStudyTheme = exports.popQuizTheme = void 0;
const material_1 = require("@mui/material");
const poptheme = (0, material_1.createTheme)({
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    textTransform: 'none',
                    '&:hover': {
                        boxShadow: 'none',
                    },
                    variants: [
                        {
                            props: { variant: 'capsuleContained' },
                            style: ({ theme, ownerState, }) => {
                                var _a, _b;
                                return ({
                                    fontSize: ownerState.size === 'small'
                                        ? '0.8125rem'
                                        : ownerState.size === 'medium'
                                            ? '0.875rem'
                                            : '0.9375rem',
                                    borderRadius: '624.9375rem',
                                    backgroundColor: ((_a = theme.palette[ownerState.color]) === null || _a === void 0 ? void 0 : _a.main) ||
                                        theme.palette.primary.main, // Use color prop
                                    color: ((_b = theme.palette[ownerState.color]) === null || _b === void 0 ? void 0 : _b.contrastText) ||
                                        theme.palette.primary.contrastText, // Use contrast text color
                                    padding: ownerState.size === 'small'
                                        ? '0.25rem, 0.63rem'
                                        : ownerState.size === 'medium'
                                            ? '0.38rem 1rem'
                                            : '0.5rem 1.38rem',
                                    // [theme.breakpoints.down('sm')]: {
                                    //   '&:active': {
                                    //     backgroundColor:
                                    //       theme.palette[ownerState.color]?.dark ||
                                    //       theme.palette.primary.dark, // Use dark color for hover
                                    //   },
                                    // },
                                    // [theme.breakpoints.up('sm')]: {
                                    //   '&:hover': {
                                    //     backgroundColor:
                                    //       theme.palette[ownerState.color]?.dark ||
                                    //       theme.palette.primary.dark, // Use dark color for hover
                                    //   },
                                    // },
                                });
                            },
                        },
                        {
                            props: { variant: 'capsuleOutlined' },
                            style: ({ theme, ownerState, }) => {
                                var _a, _b;
                                return ({
                                    fontSize: ownerState.size === 'small'
                                        ? '0.8125rem'
                                        : ownerState.size === 'medium'
                                            ? '0.875rem'
                                            : '0.9375rem',
                                    borderRadius: '624.9375rem',
                                    borderColor: (0, material_1.alpha)(((_a = theme.palette[ownerState.color]) === null || _a === void 0 ? void 0 : _a.main) ||
                                        theme.palette.primary.main, 0.5),
                                    border: '1px solid',
                                    color: ((_b = theme.palette[ownerState.color]) === null || _b === void 0 ? void 0 : _b.main) ||
                                        theme.palette.primary.main, // Use color prop
                                    padding: ownerState.size === 'small'
                                        ? '0.25rem, 0.63rem'
                                        : ownerState.size === 'medium'
                                            ? '0.38rem 1rem'
                                            : '0.5rem 1.38rem',
                                    // [theme.breakpoints.down('sm')]: {
                                    //   '&:active': {
                                    //     backgroundColor: alpha(
                                    //       theme.palette[ownerState.color]?.main ||
                                    //         theme.palette.primary.main,
                                    //       0.04
                                    //     ),
                                    //   },
                                    // },
                                    // [theme.breakpoints.up('sm')]: {
                                    //   '&:hover': {
                                    //     backgroundColor: alpha(
                                    //       theme.palette[ownerState.color]?.main ||
                                    //         theme.palette.primary.main,
                                    //       0.04
                                    //     ),
                                    //   },
                                    // },
                                });
                            },
                        },
                    ],
                },
            },
        },
    },
});
exports.popQuizTheme = (0, material_1.createTheme)(poptheme, {
    palette: {
        mode: 'light',
        primary: {
            main: '#7451EA',
            light: '#896BED',
            dark: '#6C4AE7',
        },
    },
});
exports.popStudyTheme = (0, material_1.createTheme)(poptheme, {
    palette: {
        mode: 'light',
        primary: {
            main: '#456BF4', // need to change to actual popstudy theme primary
            light: '#6283F8',
            dark: '#2551EF', // need to change to actual popstudy theme primary
        },
    },
});
exports.popQuizGameplayTheme = (0, material_1.createTheme)(exports.popQuizTheme, {
    typography: {
        h5: {
            fontSize: '1.5rem',
            '@media (min-width:600px)': {
                fontSize: '2.125rem', // Medium screens
            },
        },
    },
    palette: {
        success: {
            main: '#66BB6A',
        },
        error: {
            main: '#F44336',
        },
    },
    // components: {
    //   MuiButton: {
    //     variants: [
    //       {
    //         props: { variant: 'capsuleOutlined' },
    //         style: ({
    //           theme,
    //         }: {
    //           theme: Theme;
    //           ownerState: ButtonProps & {
    //             color: keyof Palette;
    //             size: 'small' | 'medium' | 'large';
    //           };
    //         }) => ({
    //           // [theme.breakpoints.down('sm')]: {
    //           //   '&:active': {
    //           //     backgroundColor: theme.palette.primary.dark,
    //           //   },
    //           // },
    //           // [theme.breakpoints.up('sm')]: {
    //           //   '&:hover': {
    //           //     backgroundColor: theme.palette.primary.dark,
    //           //   },
    //           // },
    //         }),
    //       },
    //     ],
    //   },
    // },
});
exports.popQuizHostGameplayTheme = (0, material_1.createTheme)(exports.popQuizTheme, {
    typography: {
        h5: {
            fontSize: '1.5rem',
            '@media (min-width:600px)': {
                fontSize: '2.125rem', // Medium screens
            },
        },
    },
    palette: {
        primary: {
            main: '#35427C', // need to change to actual host theme
        },
        success: {
            main: '#66BB6A',
        },
        error: {
            main: '#F44336',
        },
    },
    // components: {
    //   MuiButton: {
    //     variants: [
    //       {
    //         props: { variant: 'capsuleOutlined' },
    //         style: ({
    //           theme,
    //         }: {
    //           theme: Theme;
    //           ownerState: ButtonProps & {
    //             color: keyof Palette;
    //             size: 'small' | 'medium' | 'large';
    //           };
    //         }) => ({
    //           // [theme.breakpoints.down('sm')]: {
    //           //   '&:active': {
    //           //     backgroundColor: theme.palette.primary.dark,
    //           //   },
    //           // },
    //           // [theme.breakpoints.up('sm')]: {
    //           //   '&:hover': {
    //           //     backgroundColor: theme.palette.primary.dark,
    //           //   },
    //           // },
    //         }),
    //       },
    //     ],
    //   },
    // },
});
exports.popStudyGameplayTheme = (0, material_1.createTheme)(exports.popStudyTheme, {
    typography: {
        h5: {
            fontSize: '1.5rem',
            '@media (min-width:600px)': {
                fontSize: '2.125rem', // Medium screens
            },
        },
    },
    palette: {
        success: {
            main: '#66BB6A',
        },
        error: {
            main: '#F44336',
        },
    },
    // components: {
    //   MuiButton: {
    //     variants: [
    //       {
    //         props: { variant: 'capsuleOutlined' },
    //         style: ({
    //           theme,
    //         }: {
    //           theme: Theme;
    //           ownerState: ButtonProps & {
    //             color: keyof Palette;
    //             size: 'small' | 'medium' | 'large';
    //           };
    //         }) => ({
    //           // [theme.breakpoints.down('sm')]: {
    //           //   '&:active': {
    //           //     backgroundColor: theme.palette.primary.dark,
    //           //   },
    //           // },
    //           // [theme.breakpoints.up('sm')]: {
    //           //   '&:hover': {
    //           //     backgroundColor: theme.palette.primary.dark,
    //           //   },
    //           // },
    //         }),
    //       },
    //     ],
    //   },
    // },
});
